export default "__VITE_ASSET__DHsmnUas__"